import React, { useEffect, useState } from 'react';
import { Form, Layout, message } from 'antd';
import styled from '@emotion/styled';
import { appStyles } from '../../../styles';
import { UserProfileContent, UserProfileHeader, UserProfileSearch } from '../../organisms/user-profile';
import { API_URLS } from '../../../constants/urls/api-urls';
import { getUserProfileRepository } from '../../../repository/mytm/user/userMeRepository';
import { IconUserProfile } from '../../../assets';
import { SpinLoading } from '../../atoms';

const { Content } = Layout;

export const UserProfile = () => {
  const [searchEmail, setSearchEmail] = useState('');
  const [userProfile, setUserProfile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [close, setClose] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (refresh) {
      getUserProfileRepository(API_URLS.USER_PROFILE, searchEmail)
        .then((data: any) => {
          setUserProfile(data);
          setIsLoading(false);
          setRefresh(false);
          setClose(true);
        })
        .catch(err => {
          setIsLoading(false);
          setRefresh(false);
          setClose(true);
          message.error(err?.errorMessage);
        });
    }
  }, [refresh]);

  useEffect(() => {
    if (!searchEmail) {
      setClose(false);
    }
  }, [searchEmail]);

  const setValueSearch = () => {
    form.setFieldsValue({
      searchEmail: '',
    });
    setSearchEmail('');
  };

  const refreshData = () => {
    setRefresh(true);
  };

  const findItemByEmail = () => {
    const errs = form.getFieldError('searchEmail');
    if (errs && errs.length) {
      return false;
    }
    setIsLoading(true);
    getUserProfileRepository(API_URLS.USER_PROFILE, searchEmail)
      .then((data: any) => {
        setUserProfile(data);
        setIsLoading(false);
        setClose(true);
      })
      .catch(err => {
        setIsLoading(false);
        setUserProfile(null);
        setClose(true);
        message.error(err?.errorMessage);
      });
    return true;
  };

  // @ts-ignore
  return (
    <>
      <Container>
        <Content>
          <UserProfileHeader />
          <UserProfileSearch
            setSearchEmail={setSearchEmail}
            findItemByEmail={findItemByEmail}
            searchEmail={searchEmail}
            form={form}
            close={close}
            setValueSearch={setValueSearch}
          />
          <SpinLoading isLoading={isLoading} absolute>
            <div>
              {userProfile ? (
                <UserProfileContent userProfile={userProfile} setRefresh={refreshData} setIsLoading={setIsLoading} />
              ) : null}
              {!isLoading && !userProfile ? (
                <div className="d-flex justify-content-center">
                  <IconUserProfile />
                </div>
              ) : null}
            </div>
          </SpinLoading>
        </Content>
      </Container>
    </>
  );
};

const Container = styled.div`
  ${appStyles.paddingComponent}

  & .ant-pagination {
    float: right;
    padding: 15px 0 0 0;
  }

  .btn-generate-access-code,
  .btn-export-access-code {
    width: 140px;
  }
`;
